import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import AmpleHireLoader from "../loaders/ample-hire-loader";
import { useSelector, useDispatch } from "react-redux";
import ErrorToast from "../toasts/error-toast";
import Cookies from "js-cookie";
import { syncStateWithStorage } from "../../redux/slices/signin-slice";
import axiosInstance from "../../interceptors";

const AuthComponent = ({ children }) => {
  const dispatch = useDispatch();
  const { accessToken, tncStatus, userType } = useSelector(
    (state) => state.signinSliceReducer
  );
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    try {
      setLoading(true);
      dispatch(syncStateWithStorage());
      
      const token =
        localStorage.getItem("e_access_token") ||
        Cookies.get("e_access_token") ||
        accessToken;

      if (!token) {
        navigate("/signin", { replace: true });
        return;
      }
      
      if (tncStatus === false) {
        navigate("/admin/terms-of-use");
        return;
      }
      
      // Unified routing: all authenticated users use the /admin app, so we no
      // longer redirect any userType to the legacy /user app.
      /* if ((userType && userType === "manpower") && !location.pathname.startsWith("/manpower")) {
        navigate("/manpower", { replace: true });
      } */
    } catch (error) {
      console.error("Auth component error:", error);
      ErrorToast(error.message);
      navigate("/signin", { replace: true });
    } finally {
      setLoading(false);
    }
  }, [accessToken, navigate, tncStatus, userType, location.pathname, dispatch]);

  // Right after login, ask the server whether this user still has a temporary
  // password. If so, force them to the change-password screen before anything
  // else. Runs once per session (cached) and fails open so a missing/erroring
  // endpoint never blocks the app — the interceptor's 403 gate is the backstop.
  useEffect(() => {
    const token =
      localStorage.getItem("e_access_token") ||
      Cookies.get("e_access_token") ||
      accessToken;
    if (!token) return;
    if (sessionStorage.getItem("pw_state_checked") === "ok") return;

    let cancelled = false;
    (async () => {
      try {
        const r = await axiosInstance.post("/common/tenant/users/me/password-state");
        if (cancelled) return;
        if (r.data?.mustChangePassword) {
          navigate("/change-password", { replace: true });
        } else {
          sessionStorage.setItem("pw_state_checked", "ok");
        }
      } catch (_) {
        // Endpoint unavailable/errored — do not block navigation.
      }
    })();
    return () => { cancelled = true; };
  }, [accessToken, navigate]);

  return !loading ? <>{children}</> : <AmpleHireLoader />;
};

export default AuthComponent;
